import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { H2Underdog } from '../../helpers/UIElements';

import { colors } from '../../styles';

const styles = css `
  padding: 0;
  margin: 0;
  &.Image_bg {
    background-color: #ECECEC;
  }
  .WelcomeSection_title {
    font-weight: 300;
    position: relative;
    color: #000000;
    line-height: 54px;
    font-size: 35px;
    letter-spacing: 0.94px;
    @media(min-width: 992px) {
      line-height: 61px;
      font-size: 50px;
      letter-spacing: 1.31px;
    }
  }
  .WelcomeSection_titleAlt {
    @media(min-width: 992px) {
      text-align: center;
      &::after, &::before {
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .WelcomeSection_lead {
      font-weight: 700;
      font-size: 16px;
      color: ${colors.color1};
      letter-spacing: 1.68px;
      line-height: 25px;
      font-style: italic;
      padding: 0 0 20px;
      @media(min-width: 992px) {
        padding: 0 0 30px;
        font-size: 19px;
        letter-spacing: 2px;
        line-height: 31px;
        font-style: normal;
      }
    }
  .WelcomeSection_content {
    display: flex;
    justify-content: center;
    padding: 40px 20px 40px 20px;
    @media(min-width: 768px) {
      padding: 110px 0;
    }
  }
  .WelcomeSection_contentAlt {
    @media(min-width: 992px) {
      padding: 110px 50px;
      flex: 1;
    }
  }
  .WelcomeSection_image {
    height: 100%;
    margin: 0 auto;
    @media(min-width: 992px) {
      max-width: 500px;
      margin: auto;
    }
    @media(min-width: 1300px) {
      max-width: 600px;
    }
  }
  .WelcomeSection_darkText, .WelcomeSection_darkText p, .WelcomeSection_darkText span {
    color: #000000 !important;
    font-weight: 400 !important;
    @media(min-width: 992px) {
      color: #393939 !important;
    }
  }
`;

function WelcomeSection({ title, lead, image, textDark, video }) {
  return (
    <div className={`${styles} ${image ? 'Image_bg' : ''}`}>
      <div className="container-fluid">
        <div className="d-lg-flex">
          {
            image && !video &&
            <Image
              src={image}
              alt={title}
              className="w-100 order-lg-1 WelcomeSection_image"
            />
          }
          {
            video &&
            <div
              className="embed-responsive embed-responsive-16by9 w-100 order-lg-1 WelcomeSection_image"
              dangerouslySetInnerHTML={SanitizeHtml(video)}
            />
          }
          <div className={`WelcomeSection_content ${image ? 'WelcomeSection_contentAlt' : 'col-lg-8 mx-auto'}`}>
            <div className="w-100">
              <H2Underdog className={`WelcomeSection_title ${image ? '' : 'WelcomeSection_titleAlt'}`}>{title}</H2Underdog>
              <div className={`WelcomeSection_lead ${image ? '' : 'text-lg-center'} ${textDark ? 'WelcomeSection_darkText' : ''}`} dangerouslySetInnerHTML={SanitizeHtml(lead)} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

WelcomeSection.propTypes = {
  title: PropTypes.string,
  lead: PropTypes.string.isRequired,
  image: PropTypes.string,
  video: PropTypes.string,
  textDark: PropTypes.bool,
};

WelcomeSection.defaultProps = {
  title: undefined,
  image: undefined,
  video: undefined,
  textDark: false,
};

export default WelcomeSection;



// WEBPACK FOOTER //
// ./src/pages/RealtorContact/WelcomeSection.js